import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'
import * as Mortgage from '@/src/experiences/mortgage'

export const ReferralSchema = z.object({
  entry_text: z.string(),
  benefit_of_referring_mesa_card_member: z.array(z.string()),
  referrer_points_per_card_referral: z.number(),
  referee_points_per_card_referral: z.number(),
  faqs: z.record(z.string(), z.array(z.string())),
  actions: z.array(z.string()),
  disabled_partners: z.array(Mortgage.Statsig.Store.MortgageModuleVariantName),
})

export type Referral = z.infer<typeof ReferralSchema>

export function useReferralParameterStore() {
  return useMesaParameterStore('referral')
}
